module.exports = __webpack_public_path__ + "img/pump-gray.b9ec8072.png";